import styled from '@emotion/styled';
import { colors } from 'inpock-ui-react/dist/src/color';

import IconQuestionmark from '@/assets/icons/icon-questionmark.svg';
import IconCopy from '@/assets/icons/icon-copy.svg';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 22px;
  padding: 20px 15px;
`;

export const TitleContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const Title = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const SubTitle = styled.div`
  display: flex;
  align-items: center;

  &::before {
    content: '';
    display: block;
    width: 1px;
    height: 12px;
    background-color: #e5e5e5;
    margin: 0 6px;
  }
`;

export const OrderGroupContainer = styled.div`
  border-radius: 8px;
  border: 1px solid ${colors.gray200};
  padding: 12px 12px 20px;
  margin-bottom: 20px;

  .order-group-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 6px 8px;
    border-radius: 6px;
    background-color: ${colors.gray100};
    margin-bottom: 20px;
  }
`;

export const OrderItemHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const StatusBadge = styled.div`
  border-radius: 6px;
  background-color: ${colors.orange100};
  padding: 3px 6px;
`;

export const ButtonCopy = styled.div`
  width: 12px;
  height: 18px;
  background-image: url(${IconCopy});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  cursor: pointer;
`;

export const OrderItemFooter = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;

  .order-line-footer-info {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
`;

export const DeliveryFeeContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: right;
  gap: 6px;
`;

export const Icon = styled.div`
  position: relative;
  background-image: url(${IconQuestionmark});
  background-size: cover;
  width: 16px;
  height: 16px;
  cursor: pointer;
`;

export const IconWrapper = styled.div`
  position: relative;
`;
